var _rect, _path, _path2, _defs, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#f4ece5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7,0,0,0.7,149.57575757575756,282.1265587044535)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 247",
    "data-background-color": "#f4ece5",
    preserveAspectRatio: "xMidYMid meet",
    height: 623,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,75.54432,73.0841856)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 101.0316288",
    height: 101.0316288,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 101.0316288",
    height: 101.0316288,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 101.0316288",
    height: 101.0316288,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 101.0316288",
    height: 101.0316288,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 101.0316288",
    height: 101.0316288,
    width: 244.43135999999998,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 244.43135999999998 101.0316288",
    height: 101.0316288,
    width: 244.43135999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 244.43135999999998,
    viewBox: "1.9 -33.7 82.49 34.1",
    height: 101.0316288,
    "data-palette-color": "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2-14.2L9.45-12.1 22.5-12.1 21.75-14.25 16.05-31.1Q15.4-29.1 10.2-14.2L10.2-14.2ZM29.95 0L26.6 0 23.4-9.35 8.5-9.35 5.25 0 1.9 0 13.8-33.7 18.3-33.7 29.95 0ZM49.95-21.2L53.45-33.2 57.1-33.2 60.85-21.15 66.45-2.95Q69.2-15.75 70.4-21.1L70.4-21.1 73.2-33.7 76.3-33.7 68.65 0 64.4 0 61.05-10.65 55.35-29.15Q53.45-22.25 50-10.65L50-10.65 46.85 0 42.6 0 33.85-33.7 37.1-33.7 40.25-21.2 44.8-3.15Q48.15-15.1 49.95-21.2L49.95-21.2ZM80.02-0.33Q79.3-1.05 79.3-2.15 79.3-3.25 80.02-3.98 80.75-4.7 81.84-4.7 82.95-4.7 83.67-3.98 84.39-3.25 84.39-2.15 84.39-1.05 83.67-0.33 82.95 0.4 81.84 0.4 80.75 0.4 80.02-0.33Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#000000",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.013 67.084L227.013 15.762 11.338 15.762 11.338 231.438 227.013 231.438 227.013 180.116 217.902 180.116 217.902 222.327 20.449 222.327 20.449 24.873 217.902 24.873 217.902 67.084Z",
    fill: "#000000",
    stroke: "transparent",
    "data-fill-palette-color": "primary"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c8ad7cb533aecfa941b5ff2892580417.svg";
export { ForwardRef as ReactComponent };